import { Component } from '@angular/core';
import { LegalNavigationService } from 'app/service/legal-navigation.service';

// Schaltfläche "Zurück" der Rechtsseiten
@Component({
  standalone: false,
  selector: 'app-back-button',
  template: `<button type="button" class="ac-topbar__back" (click)="nav.back()">← {{ "authPages.back" | translate }}</button>`,
  styleUrls: ['./back-button.component.scss']
})
export class BackButtonComponent {
  constructor(public nav: LegalNavigationService) {}
}
